import { array, bool, func, number } from 'prop-types'
import { kuiperClassNames, PopoverV2, UnwrappedButton } from '@opallabs/kuiper'
import { SaveContentTypeInput } from './SaveContentTypeInput'
import './styles.scss'

const renderTrigger = (buttonDisabled) => (
  <UnwrappedButton
    ariaLabel="Save as Content Type"
    className={kuiperClassNames('button')}
    disabled={buttonDisabled}
    label="Save as Content Type"
    position="left"
    type="secondary"
  />
)

export const SaveContentTypePopover = ({
  buttonDisabled,
  contentTypeNames = [],
  maxLength = 25,
  onCancel,
  onSubmit,
}) => (
  <PopoverV2
    className={kuiperClassNames('save-content-type')}
    disabled={buttonDisabled}
    content={
      <SaveContentTypeInput
        contentTypeNames={contentTypeNames}
        maxLength={maxLength}
        onCancel={onCancel}
        onSubmit={onSubmit}
      />
    }
    hasCaret={false}
    popoverHandlers={{ zIndex: 100 }}
    triggerEvent="click"
    trigger={renderTrigger(buttonDisabled)}
  />
)

SaveContentTypePopover.propTypes = {
  buttonDisabled: bool,
  contentTypeNames: array,
  maxLength: number,
  onCancel: func,
  onSubmit: func,
}
